/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loosen or clear the filters to see more teams`)
};

const es_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaja o borra los filtros para ver más equipos`)
};

const de_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lockere oder lösche die Filter, um mehr Teams zu sehen`)
};

const nl_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versoepel of wis de filters om meer teams te zien`)
};

const fr_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assouplissez ou effacez les filtres pour voir plus d'équipes`)
};

const it_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenta o cancella i filtri per vedere più squadre`)
};

const pt_br2_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrouxe ou limpe os filtros para ver mais times`)
};

const pt_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alivia ou limpa os filtros para ver mais equipas`)
};

const ja_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルターを緩めるかクリアするとチームが表示されます`)
};

const zh_f1_apex_no_teams_filters_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放宽或清除筛选条件以查看更多阵容`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_no_teams_filters_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_no_teams_filters_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_no_teams_filters_hint", locale)
	if (locale === "en") return en_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "es") return es_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "de") return de_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "nl") return nl_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "fr") return fr_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "it") return it_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "pt") return pt_f1_apex_no_teams_filters_hint(inputs)
	if (locale === "ja") return ja_f1_apex_no_teams_filters_hint(inputs)
	return zh_f1_apex_no_teams_filters_hint(inputs)
};